import Splitpanes from './splitpanes.vue'
import Pane from './pane.vue'

export { Splitpanes, Pane }
